// Vendor imports
const Cookies = require('js-cookie')
const qs = require('qs')
// Shared imports
const { urlWithoutProtocol } = require('shared/utils')
// Client lib imports
const cookieLib = require('client/lib/cookie')
// Sibling imports
const { deeplinkBaseUrlState } = require('./selectors')

// Action types

const DISMISS_OPEN_IN_APP = 'OPEN_IN_APP_DISMISS'

// Action dispatchers

function openInApp() {
  return function (dispatch, getState) {
    const baseUrl = deeplinkBaseUrlState(getState())
    const deeplinkUrl = getDeeplinkUrl(baseUrl)
    location.assign(deeplinkUrl)
  }
}

function dismiss() {
  return function (dispatch) {
    setDismissedCookie()
    dispatch({ type: DISMISS_OPEN_IN_APP })
  }
}

// Helpers

function setDismissedCookie() {
  Cookies.set(
    'open-in-app-dismissed',
    '1',
    cookieLib.setAttributes('open-in-app-dismissed')
  )
}

function getDeeplinkUrl(baseUrl) {
  const queryString = qs.stringify({
    // Delivered as query parameter when handling the universal links.
    'deeplink_url': location.href,
    // Fallbacks to mix://$deeplink_path when universal links do not work.
    // Docs: https://docs.branch.io/pages/links/integrate/#deep-linking
    '$deeplink_path': urlWithoutProtocol(location.href)
  })
  return `${baseUrl}?${queryString}`
}

// Exports

module.exports = {
  // Action types
  DISMISS_OPEN_IN_APP,
  // Action dispatchers
  dismiss,
  openInApp
}
